import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import ClientsList from './pages/ClientsList';
import ClientDetails from './pages/ClientDetails';
import AddClient from './pages/AddClient';
import EditClient from './pages/EditClient';
import AddUpdate from './pages/AddUpdate';
import VersionDashboard from './pages/VersionDashboard';
import UpdatePlanning from './pages/UpdatePlanning';
import UpdateTracking from './pages/updates/UpdateTracking';
import Statistics from './pages/Statistics';
import PredefinedValuesDashboard from './pages/admin/PredefinedValuesDashboard';
import AdminDashboard from './pages/admin/AdminDashboard';
import FeedbackPage from './pages/FeedbackPage';
import FeedbackButton from './components/FeedbackButton';
import EngineeringFolder from './pages/engineering/EngineeringFolder';
import EngineeringList from './pages/engineering/EngineeringList';
import VersionsOverview from './pages/VersionsOverview';
import CompletionDashboard from './pages/CompletionDashboard';
import InfrastructureStats from './pages/Stats/InfrastructureStats';
import ServerCompletionDashboard from './pages/ServerCompletionDashboard';
import InfrastructureOverview from './pages/InfrastructureOverview';
import DeployableVersions from './pages/DeployableVersions';

function App() {
  return (
    <AuthProvider>
      <ProtectedRoute>
        <div className="min-h-screen bg-gray-100">
          <Header />
          <main className="container mx-auto px-4 py-6">
            <Routes>
              <Route path="/" element={<ClientsList />} />
              <Route path="/client/:id" element={<ClientDetails />} />
              <Route path="/add-client" element={<AddClient />} />
              <Route path="/edit-client/:id" element={<EditClient />} />
              <Route path="/client/:id/add-update" element={<AddUpdate />} />
              <Route path="/version-dashboard" element={<VersionDashboard />} />
              <Route path="/update-planning" element={<UpdatePlanning />} />
              <Route path="/update-tracking" element={<UpdateTracking />} />
              <Route path="/statistics" element={<Statistics />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/predefined-values" element={<PredefinedValuesDashboard />} />
              <Route path="/feedback" element={<FeedbackPage />} />
              <Route path="/engineering" element={<EngineeringList />} />
              <Route path="/client/:clientId/engineering" element={<EngineeringFolder />} />
              <Route path="/versions" element={<VersionsOverview />} />
              <Route path="/completion-dashboard" element={<CompletionDashboard />} />
              <Route path="/infrastructure-overview" element={<InfrastructureOverview />} />
              <Route path="/deployable-versions" element={<DeployableVersions />} />
            </Routes>
          </main>
          <FeedbackButton />
        </div>
      </ProtectedRoute>
    </AuthProvider>
  );
}

export default App;
